import { Bubble } from 'sidecar-components/molecules/Bubble'
import { Sentiment } from 'sidecar-components/types'
import { formatErrorMessage } from '@/components/errors'

/** FormErrorBubble component for displaying error messages in forms. */
interface FormErrorBubbleProps {
  /** Error message to display */
  error?: string
  /** Whether the form is currently loading/submitting */
  isLoading?: boolean
  testId?: string
}

export function FormErrorBubble({
  error,
  isLoading,
  testId = 'error-bubble',
}: FormErrorBubbleProps) {
  // Don't show error if loading or no error exists
  if (!error || isLoading) {
    return null
  }

  return (
    <div className="mb-4">
      <Bubble id={testId} sentiment={Sentiment.RISK} canDismiss={false}>
        {formatErrorMessage(error)}
      </Bubble>
    </div>
  )
}
